import {
	DPS_START,
	DPS_SUCCESS,
	DPS_FINISH,
	DPS_FAIL,
	CLEAN_DPS
} from '../types/dps';

const initialState = {
	loading: false,
	data: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		case DPS_START:
			return {
				data: null,
				loading: true
			}
		case DPS_SUCCESS:
			return {
				loading: false,
				data: action.data
			}
		case DPS_FAIL:
			return {
				loading: false,
				data: null
			}

		case CLEAN_DPS:
			return initialState

		case DPS_FINISH:
		default:
			return state;
	}
}
